import { render, staticRenderFns } from "./set-offload.vue?vue&type=template&id=fa711448&scoped=true"
import script from "./set-offload.vue?vue&type=script&lang=js"
export * from "./set-offload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa711448",
  null
  
)

export default component.exports